import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { Address, RiskModel } from '@amfam/policy/models';

import { KydSignUp } from '../../../core/store/programs/kyd';
import { KydNewAddressComponent } from '../kyd-new-address/kyd-new-address.component';

@Component({
  selector: 'app-kyd-ship-to',
  templateUrl: './kyd-ship-to.component.html',
  standalone: false
})
export class KydShipToComponent implements OnChanges {
  @Input() kydForm: UntypedFormGroup;
  @Input() risk: RiskModel;
  @Input() shipTos: Address[];
  @Output() addressChange = new EventEmitter<KydSignUp>();
  @ViewChild(KydNewAddressComponent, { static: true }) newAddressComponent: KydNewAddressComponent;

  public riskGroup: UntypedFormGroup;
  public newDeviceInput: AbstractControl;
  public shipToInput: AbstractControl;
  public displayNewAddress = false;
  public displayShipToAddress = false;

  private _address: Address;
  constructor() {}

  private get address(): Address {
    return this._address;
  }

  private set address(address: Address) {
    this._address = address;
    this.emit();
  }

  ngOnChanges() {
    this.riskGroup = <UntypedFormGroup>this.kydForm.controls['ship-' + this.risk.id];
    this.newDeviceInput = this.riskGroup.controls['newDeviceInput'];
    this.shipToInput = this.riskGroup.controls['shipTo'];

    this.updateDisplay();
    this.emit();
  }

  public handleCustomAddress(address: Address) {
    this.address = address;
    this.shipTos.push(address);
    this.shipToInput.setValue(this.shipTos.length - 1);
    this.updateDisplay();
  }

  public newDeviceChanged() {
    // If it is not a new device, reset the address.
    if (!this.riskGroup.controls['newDeviceInput'].value) {
      this.shipToInput.reset('');
    }
    this.updateDisplay();
    if (!this.displayShipToAddress) {
      this.address = undefined;
    } else {
      this.emit();
    }
  }

  public shipToChanged() {
    this.updateDisplay();

    if (!this.displayNewAddress) {
      this.address = this.shipTos[this.shipToInput.value];
    } else {
      this.address = this.newAddressComponent.address;
    }
  }

  private emit() {
    this.addressChange.emit({ address: this.address, riskModel: this.risk });
    this.updateValidity(this.riskGroup);
  }

  private updateValidity(group) {
    for (const key in group.controls) {
      if (group.controls.hasOwnProperty.call(key)) {
        const control = group.controls[key];
        if (control) {
          if (control instanceof UntypedFormGroup) {
            this.updateValidity(control);
          } else {
            control.updateValueAndValidity();
          }
        }
      }
    }
  }

  private updateDisplay() {
    this.displayShipToAddress =
      !this.risk.previouslyEnrolled || (this.newDeviceInput && this.newDeviceInput.value);
    this.displayNewAddress = this.displayShipToAddress && this.shipToInput.value === 'newShipTo';
    let hasDevice = false;
    if (this.risk.previouslyEnrolled) {
      hasDevice = !!this.newDeviceInput && !this.newDeviceInput.value;
    }
    this.risk = Object.assign({}, this.risk, { hasExistingDevice: hasDevice });
  }
}
